import React from 'react';

export const SegmentsTableEmpty: React.FC = () => {
  return (
    <div className="text-center py-12">
      <div className="text-gray-500">
        No segments found. Create your first segment to get started.
      </div>
    </div>
  );
};
